import React, { type PropsWithChildren } from 'react';
import styled, { css } from 'styled-components';

import Clickable, { type ClickableProps } from '#@/components/Clickable';
import Icon, { type IconProps } from '#@/components/Icon';
import { COLOR, mixins, sizes } from '#@/shared/utils/styles';

export const CLICKABLE_TEXT_GAP = 5;

interface WrapperProps extends ClickableProps {
  $gap: 'button' | 'default';
}

const Wrapper = styled(Clickable)<WrapperProps>`
  display: inline-flex;
  align-items: center;

  ${({ $gap }) => {
    switch ($gap) {
      case 'button':
        return css`
          gap: ${sizes.buttonGap}px;
        `;
      default:
        return css`
          gap: ${CLICKABLE_TEXT_GAP}px;
        `;
    }
  }}

  &:not(:disabled) {
    ${mixins.link(COLOR.brand)}
  }

  &:disabled {
    color: ${COLOR.textTertiary};
  }
`;

export interface ClickableTextProps extends ClickableProps {
  icon?: IconProps['type'];
  iconSize?: IconProps['size'];
  iconColor?: IconProps['color'];
  iconPosition?: 'left' | 'right';
  gap?: 'default' | 'button';
}

const ClickableText: React.FC<PropsWithChildren<ClickableTextProps>> = ({
  icon,
  iconSize,
  iconPosition = 'left',
  gap = 'default',
  iconColor,
  children,
  ...props
}) => (
  <Wrapper $gap={gap} {...props}>
    {icon && iconPosition === 'left' && <Icon type={icon} size={iconSize} color={iconColor} />}
    {children}
    {icon && iconPosition === 'right' && <Icon type={icon} size={iconSize} color={iconColor} />}
  </Wrapper>
);

export default ClickableText;
